const STORAGE_KEY = 'matchlytics_tour_seen';

/** Whether this device already saw (or skipped) the tour. */
export function hasSeenTour(): boolean {
  try {
    return !!localStorage.getItem(STORAGE_KEY);
  } catch {
    // webview safety — treat as seen so a broken storage never loops the tour
    return true;
  }
}

export function markTourSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // webview safety
  }
}
